import * as Select from '@radix-ui/react-select';
import classNames from 'classnames';
import { capitalize } from 'lodash';

import { icon_chevron_down, icon_chevron_up } from '@gn-audio/icons';
import { siteContext } from '@gn-audio/jss-core';

import { JabraIcon } from '../../../JabraIcon/JabraIcon';
import { CountryDetails } from '../CountryConstants';

import styles from './CountriesSelectComponent.module.css';

export interface SelectComponentProps {
  selected?: CountryDetails;
  countries: CountryDetails[];
  onChange?: (country: CountryDetails) => void;
}

const CountriesSelectComponent = ({ selected, onChange, countries }: SelectComponentProps) => {
  const siteName = capitalize(siteContext);
  const { locale, countryName } = selected ?? {};
  const handleChangeLocale = (selectedLocale: string) => {
    const selectedCountry = countries.find(({ locale }) => locale === selectedLocale);
    !!onChange && !!selectedCountry && onChange(selectedCountry);
  };
  return (
    <Select.Root
      defaultValue={locale}
      value={locale}
      onValueChange={(value) => handleChangeLocale(value)}
    >
      <Select.Trigger
        className={classNames(styles.selectTrigger, 'group')}
        aria-label="Country selector"
      >
        <Select.Value placeholder="Select a country">
          {siteName}&nbsp;{countryName}
        </Select.Value>
        <Select.Icon className={styles.selectIcon}>
          <JabraIcon className="h-3 w-3 group-data-[state=open]:hidden" Icon={icon_chevron_down} />
          <JabraIcon className="h-3 w-3 group-data-[state=closed]:hidden" Icon={icon_chevron_up} />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content position="popper" className={styles.selectContent}>
          <Select.ScrollUpButton className={styles.selectScrollButton}>
            <JabraIcon className="h-3 w-3" Icon={icon_chevron_up} />
          </Select.ScrollUpButton>
          <Select.Viewport className={styles.selectViewport}>
            {countries.map((country) => {
              return (
                <Select.Item
                  key={country.locale}
                  value={country.locale}
                  className={classNames(styles.selectItem, 'data-[highlighted]:bg-gray-50')}
                >
                  <Select.ItemText>
                    {siteName}&nbsp;{country.countryName}
                  </Select.ItemText>
                </Select.Item>
              );
            })}
          </Select.Viewport>
          <Select.ScrollDownButton className={styles.selectScrollButton}>
            <JabraIcon className="h-3 w-3" Icon={icon_chevron_down} />
          </Select.ScrollDownButton>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};

export default CountriesSelectComponent;
